import IconAndText from './IconAndText';

export default IconAndText;
